import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { Gap, MyButton } from "../../atoms";
import MyDialog from "../Dialog";
import CircularProgress from "@mui/material/CircularProgress";

const MyUploadFile = ({
  label,
  handleselectedFile,
  fileName,
  handleDeleteFile,
  handleDownloadFile,
  handleHistoryDokumen,
  formatLabel,
  handleView,
  loading,
  hasAccess,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const fileTypes = ["PDF"];
  const [file, setFile] = React.useState(null);
  const [fileError, setFileError] = React.useState("");
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (param) => {
    if (param === "hapus") {
      handleselectedFile(null);
    }
    if (param === "logout") {
      localStorage.clear();
    }
    setAnchorEl(null);
  };

  const handleOpenDragAndDrop = (param) => {
    if (param === "openDialog") {
      setFile(fileName);
      setOpenDialog(true);
    } else {
      setOpenDialog(false);
    }
  };

  const handleChange = (file) => {
    if (file && file.size > MAX_FILE_SIZE) {
      setFileError("Ukuran file melebihi 2MB.");
      setFile(null);
      return;
    }
    setFileError("");
    setFile(file);
  };

  const handleCloseDragAndDrop = () => {
    setOpenDialog(false);
    setFile(null);
    setFileError("");
  };

  const handleOpenDragAndDropSave = () => {
    setOpenDialog(false);
    handleselectedFile(file);
    setFile(null);
  };
  const renderValue = (
    <>
      <h3>{label}</h3>
      <div style={{ width: "100%" }}>
        <FileUploader
          handleChange={handleChange}
          name="file"
          types={fileTypes}
          label="Unggah atau Drop File Disini"
        />
        {fileError && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              backgroundColor: "#FFF3F3",
              border: "1px solid #F44336",
              borderRadius: 6,
              padding: "10px 14px",
              marginTop: 8,
              boxSizing: "border-box",
              width: "97%",
            }}
          >
            <span style={{ fontSize: 22 }}>⚠️</span>
            <div>
              <p
                style={{
                  margin: 0,
                  fontSize: 14,
                  fontWeight: 700,
                  color: "#D32F2F",
                }}
              >
                File terlalu besar!
              </p>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: 13,
                  color: "#D32F2F",
                }}
              >
                Maksimal ukuran file adalah 2MB. Silakan kompres atau pilih file
                lain.
              </p>
            </div>
          </div>
        )}
      </div>
      <p>
        {file
          ? `File name: ${file?.name ? file?.name.substring(0, 30) : file}...`
          : "no files uploaded yet"}
      </p>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          height={"100%"}
          style={{ width: "30%" }}
          borderColor="#F06524"
          onClick={handleCloseDragAndDrop}
        />
        <Gap width={20} />
        <MyButton
          component="span"
          color="#FFFFFF"
          height={"100%"}
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Simpan"
          style={{ width: "30%" }}
          borderColor="#F06524"
          onClick={handleOpenDragAndDropSave}
        />
      </div>
    </>
  );

  return (
    <>
      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleOpenDragAndDrop}
        renderValue={renderValue}
        fullWidth={true}
        maxWidth={"sm"}
      />
      <div
        style={{
          border: "1px solid #ededed",
          padding: 5,
          borderRadius: 4,
          // height: 65,
        }}
      >
        <p
          style={{
            color: "#757575",
            fontWeight: 400,
            fontSize: 13,
            marginTop: 10,
          }}
        >
          {label}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            // marginTop: -20,
            wordWrap: "break-word",
          }}
        >
          <p style={{ color: "#212121", fontWeight: 500, fontSize: 17 }}>
            {fileName ? fileName?.substring(0, 30) + "..." : ""}
          </p>

          {loading === true ? (
            <CircularProgress />
          ) : (
            <div style={{ display: "flex" }}>
              <Gap height={10} />
              {fileName === null && hasAccess && (
                <MyButton
                  component="span"
                  color="#FFFFFF"
                  backgroundColor="#F06524"
                  backgroundColorHover="#F06524"
                  variant="outlined"
                  colorHover="white"
                  children="Unggah"
                  borderColor="#F06524"
                  onClick={() => handleOpenDragAndDrop("openDialog")}
                />
              )}
              {fileName !== null && (
                <MyButton
                  style={{ marginTop: 8, height: 30 }}
                  component="span"
                  color="#FF7100"
                  backgroundColor="#FFF8E1"
                  backgroundColorHover="#FFF8E1"
                  variant="outlined"
                  colorHover="#FF7100"
                  children="Lihat"
                  borderColor="#FFF8E1"
                  onClick={handleView}
                />
              )}
              <Gap width={10} />
              {fileName && (
                <div>
                  <Gap height={10} />
                  <MoreHorizIcon
                    style={{ color: "#757575", cursor: "pointer" }}
                    onClick={handleClick}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "bottom",
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        {hasAccess ? (
          <label onClick={() => handleOpenDragAndDrop("openDialog")}>
            <MenuItem onClick={handleClose}>
              <EditIcon fontSize="10px" />
              <Gap width={5} />
              Ubah
            </MenuItem>
          </label>
        ) : null}
        <Divider />
        <label>
          <MenuItem onClick={handleDownloadFile}>
            <DownloadIcon fontSize="10px" />
            <Gap width={5} />
            Unduh
          </MenuItem>
        </label>
        <Divider />
        <label>
          <MenuItem onClick={handleHistoryDokumen}>
            <HistoryIcon fontSize="10px" />
            <Gap width={5} />
            Riwayat Dokumen
          </MenuItem>
        </label>
        <Divider />
        {hasAccess ? (
          <label>
            <MenuItem onClick={handleDeleteFile}>
              <DeleteIcon fontSize="10px" />
              <Gap width={5} />
              Hapus untuk unggah baru
            </MenuItem>
          </label>
        ) : null}
      </Menu>
      <p style={{ fontSize: 11, color: "#8B8B8B" }}>
        {formatLabel ? formatLabel : "Format: pdf (maks. 2MB)"}
      </p>
    </>
  );
};

export default MyUploadFile;
